import dayjs from 'dayjs';
import router from '@/router';
import _ from 'lodash';
import JsBarcode from 'jsbarcode';

function dataToString(date, format = 'YYYY-MM-DD HH:mm:ss', offset = 0) {
    let nowTimeZone = new Date().getTimezoneOffset() * 60000;
    offset = offset ? Number(offset) : (-nowTimeZone);
    if (date) {
        date = dayjs(date).valueOf();
        date = date + nowTimeZone;
        return dayjs(date + offset).format(format);
    } else {
        return '';
    }
}

function getRealPath(getaway) {
    // const getaway = (window.__POWERED_BY_QIANKUN__ && store) ? store.state.global.props.gateway : '';
    let localhostPaht = window.location.protocol + '//' + window.location.host;
    let realPath = localhostPaht + (window.__POWERED_BY_QIANKUN__ ? getaway : window.HS_CONST.API_PROJECTNAME);
    return realPath;
}

function getBase64(file) {
    return new Promise(function (resolve, reject) {
        let reader = new FileReader();
        let imgResult = "";
        reader.readAsDataURL(file);
        reader.onload = function () {
            imgResult = reader.result;
        };
        reader.onerror = function (error) {
            reject(error);
        };
        reader.onloadend = function () {
            resolve(imgResult);
        };
    });
}

// function clearForm(formName) {
//     if (this.$refs[formName]) {
//         this.$refs[formName].resetFields();
//     }
// }

function getTagName(tagList = []) {
    const tagNameArr = tagList.map(v => v.tagValue);
    return tagNameArr.join(';');
}

function toThousand(value) {
    if (!value) return '0';
    let intPart = Number(String(value).replace(/[a-zA-Z]/g, '')).toFixed(0); // 获取整数部分    
    let intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); // 将整数部分逢三一断
    return intPartFormat;
}

function compareFun(sortCon) {
    return function (a, b) {
        let valA = a[sortCon];
        let valB = b[sortCon];
        return valA - valB;
    };
}

function openNewWindow(routerName, target = '', query = {}) {
    const routeData = router.resolve({
        name: routerName,
        // params: params,
        query: query
    });
    window.open(routeData.href, target ? target : '_blank');
}

function getColorStyle(checkValue) {
    let className = '';
    switch (checkValue) {
        case 'ONLINE': case 'NORMAL': case 'ENABLE':
            className = 'blue';
            break;

        case 'WORKING': case 'on':
            className = 'green';
            break;

        case 'testing':
            className = 'orange';
            break;

        case 'OFFLINE': case 'TIME_OUT': case 'SUSPEND': case 'DELETED': case 'CLOSED': case 'off': case 'DISABLE': case 'UNKNOWN': case 'OVER':
            className = 'red';
            break;

        default:
            break;
    }
    return className;
}

function eslBindStatusTypeList() {
    const bindStatus = window.HS_CONST_VAL.cdiEslStatusOptions;
    let successStatus = [], errorStatus = [];
    bindStatus.forEach(item => {
        if (item.successStatus) {
            successStatus.push(item.value);
        } else {
            errorStatus.push(item.value);
        }
    });
    return {
        successStatus,
        errorStatus
    };
}

function getEslBindColor(successStatus, errorStatus, checkValue) {
    let className = '';
    if (successStatus.includes(checkValue)) {
        className = 'green';
    } else if (errorStatus.includes(checkValue)) {
        className = 'red';
    }
    if (checkValue == 1 || checkValue == 901) {
        className = 'blue';
    }
    return className;
}

function getEslStateColor(checkValue) {
    let className = '';
    switch (checkValue) {
        case 'lowPower':
            className = 'red';
            break;

        default:
            break;
    }
    return className;
}


function optionDeepTranslate(options) {
    const trees = _.cloneDeep(options);
    const _this = this;
    function getTree(mapTree = []) {
        mapTree.map(item => {
            if (item.label) {
                item.label = _this.$t(item.label);
            }
            if (item.children && item.children.length) {
                getTree(item.children);
            }
        });
    }
    getTree(trees);
    return trees;
}

function getNoZeroCostTime(value1 = 0, value2 = 0) {
    let value = value1 - value2;
    if (value !== 0 && value < 1000) {
        return `${value}ms`;
    }

    value = Math.round(value / 1000);
    let parts = [];

    if (value < 60 || value === 60) {
        parts.push(`${value}s`);
    } else {
        if (value >= 3600) {
            let h = Math.trunc(value / 3600);
            parts.push(`${h}h`);
            value %= 3600; // Remove hours from total
        }

        if (value >= 60) {
            let min = Math.trunc(value / 60);
            parts.push(`${min}min`);
            value %= 60; // Remove minutes from total
        }

        if (value > 0) {
            parts.push(`${value}s`);
        }
    }
    return parts.join(' ');
}

function getCostTime(value1 = 0, value2 = 0) {
    let value = value1 - value2;
    let usetime = '';
    if (value != 0 && value < 1000) {
        return usetime = value + 'ms';
    }
    value = Math.round(value / 1000);
    if (value < 60 || value == 60) {
        usetime = value + 's';
    }
    if (60 < value && value < 3600) {
        let min = Math.trunc(value / 60);
        let s = Math.round(value % 60);
        usetime = `${min}min ${s}s`;
    }
    if (value > 3600 || value == 3600) {
        let h = Math.trunc(value / 3600);
        let min = Math.trunc((value - h * 3600) / 60);
        let s = Math.round(value % 60);
        usetime = `${h}h ${min}min ${s}s`;
    }
    return usetime;
}

function changeSizeShow(size) {
    let num = size;
    let returnStr = (num / 100).toFixed(2);
    return num != undefined ? returnStr : '';
}

function splitCdiBatchNo(cdi = '') {
    return cdi.replace(/@/g, '\n');
}

function myToFixed(num, m = 1) {
    if (num === undefined || num === null || isNaN(Number(num))) return '';
    // 将 num 转换为数值类型
    num = Number(num);
    // 使用 Number.EPSILON 来避免浮点数计算中的精度问题
    var factor = Math.pow(10, m);
    // 四舍五入后缩小回来，并用 toFixed 确保指定小数位数
    var roundedNum = (Math.round((num + Number.EPSILON) * factor) / factor).toFixed(m);
    return roundedNum;
}

function startTimeRange(endTime) {
    let minTime = '00:00:00';
    let maxTime = '23:59:00';
    if (endTime) {
        maxTime = dayjs(`1990-01-01 ${endTime}`).subtract(1, 'm').format('HH:mm:ss');
        if (dayjs(`1990-01-01 ${endTime}`).hour() == 0 && dayjs(`1990-01-01 ${endTime}`).minute() == 0) {
            maxTime = `${endTime}:00`;
            minTime = dayjs(`1990-01-01 ${endTime}`).add(1, 'm').format('HH:mm:ss');
        }
    }
    return `${minTime} - ${maxTime}`;
}

function endTimeRange(startTime) {
    let minTime = '00:00:00';
    let maxTime = '23:59:00';
    if (startTime) {
        minTime = dayjs(`1990-01-01 ${startTime}`).add(1, 'm').format('HH:mm:ss');
        if (dayjs(`1990-01-01 ${startTime}`).hour() == 23 && dayjs(`1990-01-01 ${startTime}`).minute() == 59) {
            minTime = `${startTime}:00`;
            maxTime = dayjs(`1990-01-01 ${startTime}`).subtract(1, 'm').format('HH:mm:ss');
        }
    }
    return `${minTime} - ${maxTime}`;
}

function isEAN13(code = '') {
    if (code == '0000000000000') {
        return false;
    }
    if (code.length != 13) {
        return false;
    } else {
        let a = 0;
        let b = 0;
        let codeLast = code[12];
        for (let i = 0; i < 12; i++) {
            if (i & 1) {
                b += Number(code[i]);
            } else {
                a += Number(code[i]);
            }
        }
        let c = (b * 3 + a).toString();
        let c1 = c[c.length - 1];

        let n = 10 - c1;
        return n == 10 ? codeLast == 0 : codeLast == n;
    }
}

function textToBase64Barcode(text, codeRule = 'CODE128') {
    let canvas = document.createElement("canvas");
    JsBarcode(canvas, text, { format: codeRule });
    return canvas.toDataURL("image/png");
}

function testEslIdOrExtId(value) {
    const reg1 = /^[0-9A-Fa-f]{2}(\-[0-9a-fA-F]{2}){3}$/;
    const reg2 = /^(?:[0-9]{15}|[0-9]{18})$/;
    const reg3 = /^(?:[0-9A-Fa-f]{6}|[0-9A-Fa-f]{8})$/;
    return reg1.test(value) || reg2.test(value) || reg3.test(value);
}

function formatFileSize(input) {
    let bytes = Number(input);
    if (isNaN(bytes) || bytes < 0) {
        return '';
    }
    if (bytes < 1024) {
        return bytes + ' Bytes';
    } else if (bytes >= 1024 && bytes < 1048576) {
        return (bytes / 1024).toFixed(2) + ' KB';
    } else if (bytes >= 1048576 && bytes < 1073741824) {
        return (bytes / 1048576).toFixed(2) + ' MB';
    } else {
        return (bytes / 1073741824).toFixed(2) + ' GB';
    }
}

function dealUpdateReason(numbers = 0, showPart = 3) {
    let str = String(numbers);
    if (str.length != 7) {
        return str;
    } else {
        return [str.slice(0, 2), str.slice(2, 4), str.slice(4, 7)].slice(0, showPart);
    }
}


function dealMode(numbers, showPart = 2) {
    if (numbers == undefined) {
        return numbers;
    }
    let str = String(numbers);
    if (str.length != 4) {
        return str;
    } else {
        return [str.slice(0, 2), str.slice(2, 4)].slice(0, showPart);
    }
}

function getCookie(name) {
    let cookieValue = null;
    if (document.cookie && document.cookie !== '') {
        let cookies = document.cookie.split(';');
        for (let cookie of cookies) {
            let [cookieName, cookieValueStr] = cookie.split('=');
            if (cookieName.trim() === name) {
                cookieValue = decodeURIComponent(cookieValueStr);
                break;
            }
        }
    }
    return cookieValue;
}

async function validateFile(fileRaw) {
    try {
        await fileRaw.arrayBuffer();
        return { isValid: true };
    } catch (err) {
        return { isValid: false, errorType: `promptMessage.file${err.name}` };
    }
}

function enableDealBindStatus(status) {
    if (status != undefined) {
        let returnStatus = '';
        if (status === 0) {
            returnStatus = 'label.eslStatesuccess';
        } else if (status === 2) {
            returnStatus = 'label.eslStatecancel';
        } else {
            returnStatus = `label.bindstatus${status}`;
        }
        return returnStatus;
    } else {
        return '';
    }
}

function getJumpUrl(activeRuleList) {
    let activeRule = activeRuleList ? activeRuleList[0] : window.HS_CONST.activeRule;
    let realPath = window.location.protocol + '//' + window.location.host;
    // 判断是否使用 hash 模式
    if (window.__POWERED_BY_QIANKUN__) {
        realPath = `${realPath}/${activeRule}`;
    } else if (window.location.hash) {
        realPath = realPath + '/#';
    }
    return realPath;
}

export {
    dataToString,
    getRealPath,
    getBase64,
    // clearForm,
    getTagName,
    toThousand,
    compareFun,
    openNewWindow,
    getColorStyle,
    getEslBindColor,
    getEslStateColor,
    getCostTime,
    optionDeepTranslate,
    changeSizeShow,
    splitCdiBatchNo,
    myToFixed,
    startTimeRange,
    endTimeRange,
    textToBase64Barcode,
    isEAN13,
    testEslIdOrExtId,
    eslBindStatusTypeList,
    formatFileSize,
    dealUpdateReason,
    dealMode,
    getCookie,
    getNoZeroCostTime,
    validateFile,
    enableDealBindStatus,
    getJumpUrl,
};